import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function CreatePostModal({ open, onClose, defaultType = "PRAYER", onSuccess }) {
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open) {
      setContent("");
      setTitle("");
      setErr("");
    }
  }, [open]);

  if (!open) return null;

  async function handleSubmit(e) {
    e.preventDefault();
    
    // Validate required fields
    if (!title.trim()) {
      setErr("Title is required");
      return;
    }
    
    // Check if content has actual text (not just HTML tags)
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;
    const textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    if (!textContent.trim()) {
      setErr("Description is required");
      return;
    }
    
    setSubmitting(true);
    setErr("");
    try {
      const res = await axios.post(
        "/api/community/posts",
        {
          type: defaultType,
          title: title.trim(),
          content: content.trim(),
          isAnonymous: false,
        },
        { withCredentials: true }
      );
      if (!(res && res.status >= 200 && res.status < 300)) {
        throw new Error(`HTTP ${res?.status}`);
      }
      onSuccess?.();
    } catch (e) {
      setErr("Create post failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-4" onClick={handleBackdropClick}>
      <div className="w-full max-w-2xl rounded-2xl bg-white p-5">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">
            {defaultType === "PRAYER" ? "Create a Prayer Request" : "Create Praise & Miracle Report"}
          </h3>
          <button onClick={onClose} className="rounded-lg px-2 py-1 text-slate-600 hover:bg-slate-100">✕</button>
        </div>

        <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={defaultType === "PRAYER" ? "Title (required)" : "Title (required)"}
            className="w-full border border-gray-400 px-4 py-2"
            required
          />
          <ReactQuill
            theme="snow"
            modules={{
              toolbar: [
                ["bold", "italic", "underline", "strike"],
                [{ align: [] }],
                [{ color: [] }, { background: [] }],
                ["blockquote", "code-block"],
                [
                  { list: "ordered" },
                  { list: "bullet" },
                ],
                [{ size: ["small", false, "large", "huge"] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["clean"],
              ],
            }}
            value={content}
            onChange={setContent}
            placeholder={defaultType === "PRAYER" ? "Write Prayer Request… (required)" : "Write Praise and Miracle Reports… (required)"}
            className="bg-white border focus-within:ring-2 focus-within:ring-blue-500"
          />
          <p className="text-xs text-slate-500">Your post will be visible after admin approval.</p>
          {err && <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}

          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="rounded-xl border px-4 py-2">Cancel</button>
            <button
              type="submit"
              disabled={submitting}
              className="rounded-xl bg-blue-600 px-4 py-2 text-white disabled:opacity-60"
            >
              {submitting ? "Submitting…" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}


